import Service from "../../AuthService";
const Material = {
    getMaterial(page) {
        return Service.get("/material?page="+page);
    },
    showMaterial(id) {
        return Service.get("/material/" + id);
    },
    updateMaterial(id, data) {
        return Service.put("/material/" + id, data);
    },
    createMaterial(data) {
        return Service.post("/material", data);
    },
    deleteMaterial(id) {
        return Service.delete("/material/" + id);
    },
    searchMaterial(page,data) {
        return Service.post("search-material?page="+page+"&code=" + data.code +"&type="+data.type);
    },
    getMaterialAll(){
        return Service.get("/material-get-all");
    },
    //วัสดุอุปกรณ์โรงงาน
    getFactorialMaterial(){
        return Service.get("/factorial-material");
    },
    createMaterialType(data){
        return Service.post("/create_material_type",data);
    },
    updateMaterialType(data){
        return Service.post("/update_material_type/"+data.id,data);
    },
};
export default Material;
